import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { sanitizeQueryParams } from '../helpers';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  public updateQueryParams(queryParams: Record<string, any>) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: sanitizeQueryParams(queryParams),
      queryParamsHandling: 'merge',
    });
  }
}
